import { ReactComponent as UsFlag } from '../../../../../assets/images/flags/us.svg'
import { ReactComponent as CaFlag } from '../../../../../assets/images/flags/ca.svg'

export type AccountResidency = 'us' | 'ca'

export interface ResidencyOption {
  id: AccountResidency
  label: string
  Flag: typeof UsFlag
}

export const RESIDENCY_OPTIONS: ResidencyOption[] = [
  { id: 'us', label: 'United States', Flag: UsFlag },
  { id: 'ca', label: 'Canada', Flag: CaFlag },
]

export const findResidencyOption = (residency: string): ResidencyOption | undefined => RESIDENCY_OPTIONS.find(({ id }) => id === residency)
